import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-renoshop',
  templateUrl: './renoshop.component.html',
  styleUrls: ['./renoshop.component.scss']
})
export class RenoshopComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
